import Vue from 'vue'
import VueRouter from 'vue-router'
import chinese_home from '../views/chinese_home'
// import english from '../views/english_home'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'chinese_home',
    component: chinese_home
  },
  {
    path: '/english',
    name: 'english',
    component: () => import('../views/english_home.vue')
  }
];

const router = new VueRouter({
  routes
});

export default router
